import {StyleSheet, TextStyle} from 'react-native';

import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    height: '100%',
    minHeight: '100%',
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH,
    alignSelf: 'center' as const,
    backgroundColor: white,
  },
  iconsGap: {
    flex: 0,
    minWidth: 0,
  },
  featureFeedback: {
    marginTop: 10,
  },
  plusIcon: {
    marginLeft: 'auto',
  },
  title: {
    fontSize: 16,
    lineHeight: 24,
    whiteSpace: 'nowrap',
    flexShrink: 0,
  } as TextStyle,
  iconLeft: {
    fontSize: 26,
    marginRight: 10,
  },
});
